module.exports = __webpack_public_path__ + "img/main.fee95ff.png";